import { render, staticRenderFns } from "./new-company.vue?vue&type=template&id=7b6ab0ad&"
import script from "./new-company.vue?vue&type=script&lang=js&"
export * from "./new-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports